import React from 'react';

// Icona SVG user-minus, stile semplice e moderna
export default function UserMinusIcon({ size = 28, color = '#d32f2f', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      {/* Testa */}
      <circle cx="9" cy="8" r="4" stroke={color} strokeWidth="2" fill="white" />
      {/* Corpo */}
      <path d="M15 20v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1" stroke={color} strokeWidth="2" fill="white" />
      {/* Meno */}
      <rect x="16" y="10.5" width="6" height="3" rx="1.5" fill={color} />
    </svg>
  );
}
